import ThreeJSMediator from "../../../utils/threejs/ThreeJSMediator";
import threeDSettings from "../../../utils/threejs/three-d-settings";
import {
  SUCCESS,
  GET_THREE_D_VIEWER,
  START,
  FAIL
} from "../constants/action-types";

export const enableThreeDViewer = (element) => (dispatch, getState) => {
  const {
    condition: {product, side, variants},
    designs,
    product: {
      meta: {designs: designsInfo}
    }
  } = getState();
  const updateDesignsInfo = designsInfo.map((design, i) => {
    return {...designs[i], ...design};
  });
  dispatch({
    type: GET_THREE_D_VIEWER + START
  });
  ThreeJSMediator.enable(element);
  (async () => {
    if (threeDSettings && threeDSettings[product]) {
      try {
        await ThreeJSMediator.applySettings({
          ...threeDSettings[product],
          condition: {
            product,
            side,
            variants
          },
          designs: updateDesignsInfo
        });
        dispatch({
          type: GET_THREE_D_VIEWER + SUCCESS
        });
      } catch (err) {
        dispatch({
          type: GET_THREE_D_VIEWER + FAIL
        });
        throw err;
      }
    }
  })();
};
export const disableThreeDViewer = () => () => {
  ThreeJSMediator.disable();
};
